import React from 'react';
import { ArrowUpRight, MapPin } from 'lucide-react';
import { Startup } from '../data/startups';
interface StartupCardProps {
  startup: Startup;
  variant?: 'compact' | 'featured';
}
export function StartupCard({
  startup,
  variant = 'compact'
}: StartupCardProps) {
  const initial = startup.name.charAt(0).toUpperCase();
  if (variant === 'featured') {
    return <a href="#" className="group relative flex flex-col justify-between rounded-xl border border-neutral-200 bg-white p-6 transition-all hover:-translate-y-1 hover:border-neutral-300 hover:shadow-sm" data-id="element-108">
        <div data-id="element-109">
          <div className="flex items-start justify-between" data-id="element-110">
            <div className={`flex h-12 w-12 items-center justify-center rounded-lg text-lg font-bold ${startup.colorClass}`} data-id="element-111">
              {initial}
            </div>
            <div className="rounded-full border border-neutral-200 bg-neutral-50 px-2.5 py-1 text-xs font-medium text-neutral-600" data-id="element-112">
              {startup.category}
            </div>
          </div>

          <h3 className="mt-4 text-xl font-semibold tracking-tight text-neutral-900" data-id="element-113">
            {startup.name}
          </h3>
          <p className="mt-2 text-sm text-neutral-500 line-clamp-2" data-id="element-114">
            {startup.tagline}
          </p>
        </div>

        <div className="mt-6 flex items-center justify-between border-t border-neutral-100 pt-4" data-id="element-115">
          <div className="flex items-center gap-3 text-xs text-neutral-500" data-id="element-116">
            <span className="flex items-center gap-1" data-id="element-117">
              <MapPin className="h-3.5 w-3.5" data-id="element-118" />
              {startup.location}
            </span>
            <span data-id="element-119">•</span>
            <span data-id="element-120">{startup.stage}</span>
          </div>
          <span className="inline-flex items-center gap-1 text-sm font-medium text-neutral-900 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-121">
            Visit <ArrowUpRight className="h-4 w-4" data-id="element-122" />
          </span>
        </div>
      </a>;
  }
  return <a href="#" className="group relative flex flex-col rounded-xl border border-neutral-200 bg-white p-5 transition-all hover:-translate-y-0.5 hover:border-neutral-300 hover:shadow-sm" data-id="element-123">
      <div className="absolute right-5 top-5 text-neutral-300 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-neutral-900" data-id="element-124">
        <ArrowUpRight className="h-4 w-4" data-id="element-125" />
      </div>

      <div className="flex items-center gap-4" data-id="element-126">
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-base font-bold ${startup.colorClass}`} data-id="element-127">
          {initial}
        </div>
        <div data-id="element-128">
          <h3 className="text-base font-semibold tracking-tight text-neutral-900" data-id="element-129">
            {startup.name}
          </h3>
          <div className="mt-1 flex items-center gap-2 text-xs text-neutral-500" data-id="element-130">
            <span className="flex items-center gap-1" data-id="element-131">
              <span className="h-1.5 w-1.5 rounded-full bg-neutral-300" data-id="element-132" />
              {startup.category}
            </span>
          </div>
        </div>
      </div>

      <p className="mt-4 text-sm text-neutral-600 line-clamp-2" data-id="element-133">
        {startup.tagline}
      </p>

      <div className="mt-4 flex items-center gap-3 text-xs text-neutral-400" data-id="element-134">
        <span data-id="element-135">{startup.location}</span>
        <span data-id="element-136">•</span>
        <span data-id="element-137">{startup.stage}</span>
      </div>
    </a>;
}